import type { GuideFeedbackState } from '@/lib/guide-feedback';
import { apiGet, apiPost } from './api-client';

export async function getGuideFeedbackStats(
  categoryId: string,
  slug: string
): Promise<{ likes: number; dislikes: number }> {
  const res = await apiGet<{ data: { likes: number; dislikes: number } }>(
    `/guide-feedback/${categoryId}/${slug}/stats`
  );
  return res.data ?? { likes: 0, dislikes: 0 };
}

export async function voteGuide(
  categoryId: string,
  slug: string,
  vote: 'like' | 'dislike'
): Promise<{ likes: number; dislikes: number }> {
  const res = await apiPost<{ data: { likes: number; dislikes: number } }>(
    `/guide-feedback/${categoryId}/${slug}/vote`,
    { vote }
  );
  return res.data;
}

export async function submitNegativeFeedback(input: {
  categoryId: string;
  slug: string;
  message: string;
  xatUsername?: string;
}): Promise<void> {
  await apiPost('/guide-feedback/messages', input);
}

export type GuideFeedbackSummary = GuideFeedbackState;

export async function getAdminFeedbackSummary(): Promise<GuideFeedbackSummary | null> {
  try {
    const res = await apiGet<{ data: GuideFeedbackSummary }>('/admin/guide-feedback', true);
    return res.data ?? null;
  } catch {
    return null;
  }
}
